import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BiensImmobsBiensImmobs } from 'app/services/biens-immobs/biens-immobs.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-liste-biens-immob',
  templateUrl: './liste-biens-immob.component.html',
  styleUrls: ['./liste-biens-immob.component.scss']
})
export class ListeBiensImmobComponent implements OnInit {

  public biens:any
  dataSource = new MatTableDataSource();
  constructor(private biensService:BiensImmobsBiensImmobs) { }

  getData(){
    this.biensService.getListBiensImmobs().subscribe(data =>{
      this.biens=data
    })
  }
    ngOnInit(): void {
      this.biensService.refreshNedeed.subscribe(() => this.getData());
      this.getData()
    }
    // SupprimerBiensImmobs(BiensImmobs: any) {
    //   this.biensService.deleteBiensImmobs(BiensImmobs.id).subscribe((response: any) => {
  
  
    //     console.log(this.dataSource.data);
  
  
    //   });
    //   setTimeout(() => {
    //     this.getData()
    //   }, 500)
  
    // }
  
    SupprimerBiensImmobs(BiensImmobs: any,i) {
      Swal.fire({
        title: "Êtes-vous sûr(e) ?",
        text: "Vous ne pourrez pas revenir en arrière !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimez-le."
      }).then((result) => {
        if (result.isConfirmed) {
      // this.biensService.deleteBiensImmobs(BiensImmobs.id).subscribe((response: any) => {
        this.biensService.deleteBiensImmobs(BiensImmobs.id).subscribe((response: any) => {

            this.biens.splice(i,1)
    
            // If you want to show a success message after the deletion, use another Swal.fire here
            Swal.fire({
              title: "Supprimé!",
              text: "Votre agence a été supprimée.",
              icon: "success"
            });
            // Fetch the updated data after deletion
            // setTimeout(() => {
            //   this.getagencesTunis();
            // }, 500);
          
          });
        }
      });
    }


}
